import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Editing,
  Form,
  Popup,
  // SearchPanel,
} from "devextreme-react/data-grid";
import HtmlEditor, { MediaResizing } from "devextreme-react/html-editor";
import {
  axios,
  TransactionTypeEnum,
  changeDisplayedName,
  TransactionActionTypeEnum,
} from "../../../common";
export default function EmailSettingTable({ dataSource = [] }) {
  const [columns, setColumns] = React.useState([]);
  const [body, setBody] = React.useState("");
  const formData = React.useRef({});
  React.useEffect(() => {
    const fetchColumn = async () => {
      const { data } = await axios.get("ScreenSetting", {
        params: {
          $filter: "ScreenCode eq 'P0056'",
        },
      });
      setColumns(data.value);
    };
    fetchColumn();
  }, []);
  return (
    <>
      <DataGrid
        dataSource={dataSource}
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        onRowInserting={(e) => {
          setBody("");
          e.data.Message = formData.current.Message;
        }}
        onRowUpdating={(e) => {
          e.newData.Message = formData.current.Message;
        }}
        onEditingStart={(e) => {
          setBody(e.data.Message);
          formData.current.Message = e.data.Message;
        }}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />

        <Editing
          mode="popup"
          allowAdding={true}
          allowDeleting={false}
          allowUpdating={true}
        >
          <Popup
            title="Thêm mới Email"
            showTitle={true}
            width={1100}
            height={725}
          />
          <Form>
            <Item itemType="group" colSpan={2}>
              <Item dataField="Subject" />
              <Item dataField="TransactionType"  />
              <Item dataField="TransactionActionType" />
            </Item>

            <Item itemType="group" colSpan={2}>
              <Item dataField="Message">
                <HtmlEditor
                  height={320}
                  valueType={"html"}
                  onValueChanged={(e) => (formData.current.Message = e.value)}
                  defaultValue={body}
                >
                  <MediaResizing enabled={true} />
                  <Toolbar multiline={true}>
                    <Item name="undo" />
                    <Item name="redo" />
                    <Item name="separator" />
                    <Item
                      name="size"
                      acceptedValues={[
                        "8pt",
                        "10pt",
                        "12pt",
                        "14pt",
                        "18pt",
                        "24pt",
                        "36pt",
                      ]}
                    />
                    <Item
                      name="font"
                      acceptedValues={[
                        "Arial",
                        "Courier New",
                        "Georgia",
                        "Impact",
                        "Lucida Console",
                        "Tahoma",
                        "Times New Roman",
                        "Verdana",
                      ]}
                    />
                    <Item name="separator" />
                    <Item name="bold" />
                    <Item name="italic" />
                    <Item name="strike" />
                    <Item name="underline" />
                    <Item name="separator" />
                    <Item name="alignLeft" />
                    <Item name="alignCenter" />
                    <Item name="alignRight" />
                    <Item name="alignJustify" />
                    <Item name="separator" />
                    <Item name="orderedList" />
                    <Item name="bulletList" />
                    <Item name="separator" />
                    <Item
                      name="header"
                      acceptedValues={[false, 1, 2, 3, 4, 5]}
                    />
                    <Item name="separator" />
                    <Item name="color" />
                    <Item name="background" />
                    <Item name="separator" />
                    <Item name="link" />
                    <Item name="image" />
                    <Item name="separator" />
                    <Item name="clear" />
                    <Item name="codeBlock" />
                    <Item name="blockquote" />
                    <Item name="separator" />
                    <Item name="insertTable" />
                    <Item name="deleteTable" />
                    <Item name="insertRowAbove" />
                    <Item name="insertRowBelow" />
                    <Item name="deleteRow" />
                    <Item name="insertColumnLeft" />
                    <Item name="insertColumnRight" />
                    <Item name="deleteColumn" />
                  </Toolbar>
                </HtmlEditor>
              </Item>
              <Item dataField="Remarks" editorType="dxTextArea" />
            </Item>
          </Form>
        </Editing>

        {columns?.map((column) => {
          const { DataField, Caption, DataType, VisibleIndex, Visible } =
            column;
          return (
            <Column
              key={DataField}
              dataField={DataField}
              caption={Caption}
              dataType={DataType}
              index={VisibleIndex}
              visible={Visible}
            />
          );
        })}
        <Column
          dataField="TransactionType"
          caption="Transaction Type"
          lookup={{
            dataSource: TransactionTypeEnum,
            displayExpr: changeDisplayedName(),
            valueExpr: "value",
          }}
        />
        <Column
          dataField="TransactionActionType"
          caption="Transaction Action Type"
          lookup={{
            dataSource: TransactionActionTypeEnum,
            displayExpr: changeDisplayedName(),
            valueExpr: "value",
          }}
        />
      </DataGrid>
    </>
  );
}
